<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D50rqP/tc-custom/9781682613757.jpg?1725275974978" alt="This image is the cover for the book Journal: Martial Law, The Journal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journal: Martial Law, The Journal Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A crumbling country, an emotional reunion, and a rush of violence bring the post-apocalyptic thriller series to a stunning conclusion. </b><br/><br/>John Tiggs, mining engineer and munitions expert, tried to get back to the small town of Moose Creek after the first ash fall from the Yellowstone caldera. Instead, he got picked up during a martial law crackdown and thrown in a labor camp. To free himself, he agrees to work for FEMA for six months helping with their rescue and recovery efforts. It is hard and dangerous work, but John finds it emotionally satisfying, knowing that he is making a difference.<br/><br/>Nearly two years later, John is finally on his way home to an unknown reception—he let a lot of people down when he left, and now it’s time he made it up to them.<br/><br/>Meanwhile, Allexa Smeth, Emergency Manager and reluctant deputy mayor of Moose Creek, has her own problems when a band of rogue militants comes to town and tries to seize control. With Colonel James Andrews missing, Allexa must enlist the help of the nearby military base to save her town from an even bigger threat.<br/><br/><b>“Learning from survival fiction is one of my passions although I do recognize and accept that many of the scenarios are quite extreme. Still, as a prepper that is continually challenged by the pursuit of knowledge, I keep reading and keep playing the ‘what if’ game in my own mind.  One of the best series of books for doing so is Deborah D. Moore’s The Journal series.” —<i>Backdoor Survival</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah D. Moore
      </h2>
      
      <p class="authorDescription body article">Deborah Moore is single and lives a quiet life in the Upper Peninsula of Michigan with her cat.  She was born and raised in Detroit, and has been writing poems and short stories since she was a young teen.  She moved to a small town to raise her two young sons, and then moved to an even smaller town to pursue her dreams of being self-sufficient and to explore her lifelong love of writing.  Her first published novel, The Journal: Cracked Earth, made the bestseller list in just six weeks, and was followed by Ash Fall, Crimson Skies, Raging Tides and Fault Line.  Deborah has promised that although this is the conclusion of The Journal, she has more books coming.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Deborah D. Moore
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c06109c